//Masters

import TenantList from "../pages/cpanel/tenant";
import AddTenant from "../pages/cpanel/tenant/add";
import EditTenant from "../pages/cpanel/tenant/edit";
import BranchList from "../pages/cpanel/branch";
import AddBranch from "../pages/cpanel/branch/add";
import EditBranch from "../pages/cpanel/branch/edit";
import DepartmentList from "../pages/cpanel/department";
import AddDepartment from "../pages/cpanel/department/add";
import EditDepartment from "../pages/cpanel/department/edit";
import AdminList from "../pages/cpanel/admin";
import AddAdmin from "../pages/cpanel/admin/add";
import EditAdmin from "../pages/cpanel/admin/edit";

import TenantSharing from "../pages/cpanel/tenant_sharing";

//Composers

import { TenantComposer } from "../composers/TenantComposer";
import { BranchComposer } from "../composers/BranchComposer";
import { EmployeeComposer } from "../composers/EmployeeComposer";
import { AdminComposer } from "../composers/AdminComposer";

import { DepartmentComposer } from "../composers/DepartmentComposer";

import { TenantSharingComposer } from "../composers/TenantSharingComposer";

import { DashboardComposer } from "../composers/DashboardComposer";
// Guards
import AuthGuard from "../components/guards/AuthGuard";
import DashboardLayout from "../layouts/Dashboard";
import AddEmployee from "../pages/cpanel/employee/add";
import EditEmployee from "../pages/cpanel/employee/edit";
import EmployeeList from "../pages/cpanel/employee";
import TenantDetailPage from "../pages/cpanel/tenant/TenantDetailPage";
import ProtectedLayout from "../layouts/ProtectedLayout";
import AddMapUser from "../pages/cpanel/map_users/add";
import EditMapUser from "../pages/cpanel/map_users/edit";
import MapUserList from "../pages/cpanel/map_users/list";
import { MapUserComposer } from "../composers/MapUserComposer";

const CpanelRoutes = {
  path: "cpanel",
  element: (
    <AuthGuard>
      <DashboardComposer>
        <DashboardLayout />
      </DashboardComposer>
    </AuthGuard>
  ),
  roles: ["SUPER_ADMIN", "ADMIN", "DOT"],
  children: [
    {
      path: "map-user",
      children: [
        {
          path: "",
          element: (
            <ProtectedLayout>
              <MapUserComposer>
                <MapUserList />
              </MapUserComposer>
            </ProtectedLayout>
          ),
        },
        {
          path: "list",
          element: (
            <ProtectedLayout>
              <MapUserComposer>
                <MapUserList />
              </MapUserComposer>
            </ProtectedLayout>
          ),
        },
        {
          path: "add",
          element: (
            <ProtectedLayout>
              <MapUserComposer>
                <AddMapUser />
              </MapUserComposer>
            </ProtectedLayout>
          ),
        },
        {
          path: "edit",
          element: (
            <ProtectedLayout>
              <MapUserComposer>
                <EditMapUser />
              </MapUserComposer>
            </ProtectedLayout>
          ),
        },
      ],
    },
    {
      path: "tenant",
      children: [
        {
          path: "add",
          element: (
            <ProtectedLayout>
              <TenantComposer>
                <AddTenant />
              </TenantComposer>
            </ProtectedLayout>
          ),
          roles: ["SUPER_ADMIN", "ADMIN", "DOT"],
        },
        {
          path: "edit",
          element: (
            <ProtectedLayout>
              <TenantComposer>
                <EditTenant />
              </TenantComposer>
            </ProtectedLayout>
          ),
          roles: ["SUPER_ADMIN", "ADMIN", "DOT"],
        },
        {
          path: "list",
          element: (
            <ProtectedLayout>
              <TenantComposer>
                <TenantList />
              </TenantComposer>
            </ProtectedLayout>
          ),
          roles: ["SUPER_ADMIN", "ADMIN", "DOT"],
        },
        {
          path: "details",
          element: (
            <ProtectedLayout>
              <TenantComposer>
                <TenantDetailPage loadingFrom="normalPage" />
              </TenantComposer>
            </ProtectedLayout>
          ),
        },
      ],
    },
    {
      path: "branch",
      children: [
        {
          path: "add",
          element: (
            <ProtectedLayout>
              <BranchComposer>
                <AddBranch />
              </BranchComposer>
            </ProtectedLayout>
          ),
        },
        {
          path: "edit",
          element: (
            <ProtectedLayout>
              <BranchComposer>
                <EditBranch />
              </BranchComposer>
            </ProtectedLayout>
          ),
        },
        {
          path: "list",
          element: (
            <ProtectedLayout>
              <BranchComposer>
                <BranchList />
              </BranchComposer>
            </ProtectedLayout>
          ),
        },
      ],
    },
    {
      path: "department",
      children: [
        {
          path: "add",
          element: (
            <ProtectedLayout>
              <DepartmentComposer>
                <AddDepartment />
              </DepartmentComposer>
            </ProtectedLayout>
          ),
        },
        {
          path: "edit",
          element: (
            <ProtectedLayout>
              <DepartmentComposer>
                <EditDepartment />
              </DepartmentComposer>
            </ProtectedLayout>
          ),
        },
        {
          path: "list",
          element: (
            <ProtectedLayout>
              <DepartmentComposer>
                <DepartmentList />
              </DepartmentComposer>
            </ProtectedLayout>
          ),
        },
      ],
    },

    {
      path: "sharing",
      children: [
        {
          path: "list",
          element: (
            <ProtectedLayout>
              <TenantSharingComposer>
                <TenantSharing />
              </TenantSharingComposer>
            </ProtectedLayout>
          ),
        },
      ],
    },
    {
      path: "employee",
      children: [
        {
          path: "add",
          element: (
            <ProtectedLayout>
              <EmployeeComposer>
                <AddEmployee />
              </EmployeeComposer>
            </ProtectedLayout>
          ),
        },
        {
          path: "edit",
          element: (
            <ProtectedLayout>
              <EmployeeComposer>
                <EditEmployee />
              </EmployeeComposer>
            </ProtectedLayout>
          ),
        },
        {
          path: "list",
          element: (
            <ProtectedLayout>
              <EmployeeComposer>
                <EmployeeList />
              </EmployeeComposer>
            </ProtectedLayout>
          ),
        },
      ],
    },
    {
      path: "admin",
      children: [
        {
          path: "add",
          element: (
            <ProtectedLayout>
              <AdminComposer>
                <AddAdmin />
              </AdminComposer>
            </ProtectedLayout>
          ),
        },
        {
          path: "edit",
          element: (
            <ProtectedLayout>
              <AdminComposer>
                <EditAdmin />
              </AdminComposer>
            </ProtectedLayout>
          ),
        },
        {
          path: "list",
          element: (
            <ProtectedLayout>
              <AdminComposer>
                <AdminList />
              </AdminComposer>
            </ProtectedLayout>
          ),
        },
      ],
    },
  ],
};

export default CpanelRoutes;
